import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const TIStyrvardeMeny: IRutinInfo[] = [
  rutinInfos.rtnTidGrupp,
  rutinInfos.rtnTIInstallningar,
  rutinInfos.rtnVeckoschema,
  rutinInfos.rtnDagschema,
  rutinInfos.rtnSchemaOB,
  rutinInfos.rtnTidbank,
  rutinInfos.rtnLoneartKategori,
  rutinInfos.rtnRapporteringskod,
  rutinInfos.rtnRapporteringskod2,
  rutinInfos.rtnAnstalldKategori,
  rutinInfos.rtnFaktureringstyp,
  rutinInfos.rtnPrioritet,
  rutinInfos.rtnEnhet,
  rutinInfos.rtnTIAttestomraden,
  rutinInfos.rtnTIAttestkategorier,
  rutinInfos.rtnLonearter,
];

export default TIStyrvardeMeny;
